import type React from 'react';
import styled from 'styled-components';
import { anchorOffset } from 'app/shared/styles/_mixins';

import NeighborhoodLink from 'app/shared/modules/hdp/NeighborhoodLink';
import SimilarListingsContainer from 'app/shared/modules/hdp/SimilarListingsContainer';

const AnchorOffset = styled.a`
  ${anchorOffset}
`;

interface ExpiredRecommendationsProps {
  onListingClick?: () => void;
}

const ExpiredRecommendations: React.FC<ExpiredRecommendationsProps> = ({ onListingClick }) => (
  <div className="ExpiredRecommendationsHeader">
    <AnchorOffset id="SimilarListings" />
    <SimilarListingsContainer onClick={onListingClick} hideTable />
    <NeighborhoodLink />
  </div>
);

export default ExpiredRecommendations;
